/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useState, useEffect} from 'react';
import {
  Link,
  useNavigate,
  useSearchParams,
  useLocation
} from 'react-router-dom';
import * as AuthService from '../services/auth';
import {toast} from 'react-toastify';
const Blank = () => {
  const location2 = useLocation();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [token, setToken] = useState(searchParams.get('token') || '-');
  const [location, setLocation] = useState(
    searchParams.get('location') || '0,0'
  );
  const [menus, setMenus] = useState([]);

  useEffect(() => {
    downloadMenu(searchParams.get('token'), searchParams.get('location'));
    // เซฟ token อย่างไรให้ไม่เปลี่ยนหน้า
    localStorage.setItem('token', searchParams.get('token') || '');
    localStorage.setItem('gatekeeper_token', searchParams.get('token') || '');
  }, []);

  const downloadMenu = async (token: any, location: any) => {
    try {
      const menus = await AuthService.downloadMenus(token, location);
      console.log(menus);
      setMenus(menus);

      if (menus.length === 0) {
        toast.warning('ไม่พบเมนูการใช้งาน');
      }
    } catch (error: any) {
      setMenus([]);
      toast.warning('ไม่พบเมนูการใช้งาน');
    }
  };

  return (
    <>
      <div className="menu-grid p-4">
        {menus.map((e: any) => (
          <div
            className="menu-item"
            onClick={() => {
              navigate(e.path);
            }}
          >
            <div className="icon">{e.icon}</div>
            <div className="menu-content">
              <div className="menu-title">{e.title}</div>
              <div className="menu-subtitle">{e.subtitle}</div>
            </div>
            <div className="arrow">›</div>
          </div>
        ))}
      </div>
      <p style={{ textAlign: 'center', width: '100%' }}>
        location: {location}
      </p>
    </>
  );
};

export default Blank;
